import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTCLI_Promotions,
  TXTWCL_Bet_on_all_major_sports_with_X_ELL
} from './sportsPromotions.messages.json';

const sportsPromotionsWidgets = [
  {
    title: 'Sports Promotion Grid Widget',
    _content_type_uid: SportsWidgetType.SportsPromotionGrid
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsPromotions = buildSportsLayoutPageResponse({
  alias: 'sportsPromotions',
  seoConfig: {
    descriptionTag: TXTWCL_Bet_on_all_major_sports_with_X_ELL,
    titleTag: TXTCLI_Promotions
  },
  mainSectionWidgetConfigs: sportsPromotionsWidgets
});
